import React, { Component } from 'react';
import { connect } from 'react-redux';
import HighlightsComponent from './HighlightsComponent';

class Highlights extends Component {
  constructor(props) {
    super(props);

    const idSuffix = props.airlineWhitelabel ? `.${props.airlineWhitelabel.hostname}` : '';

    this.highlights = [
      { id: `footer.component.marketing.text.1${idSuffix}`, defaultMessage: '3000 selected hotels' },
      { id: `footer.component.marketing.text.2${idSuffix}`, defaultMessage: '21 departure airports' },
      { id: `footer.component.marketing.text.3${idSuffix}`, defaultMessage: 'More than 100 destinations' },
      { id: `footer.component.marketing.text.4${idSuffix}`, defaultMessage: 'Full flexibility on dates' },
      {
        id: `footer.component.marketing.text.5${idSuffix}`,
        defaultMessage: 'Fastest growing travel agency in the Nordic region',
      },
      {
        id: `footer.component.marketing.text.6${idSuffix}`,
        defaultMessage: 'Book your trip, quick and easy, and for the best price!',
      },
    ];
  }

  render() {
    const { airlineWhitelabel } = this.props;

    return <HighlightsComponent highlights={this.highlights} airlineWhitelabel={airlineWhitelabel} />;
  }
}

function mapStateToProps(state) {
  return {
    airlineWhitelabel: state.settings.value.airlineWhitelabel,
  };
}

export default connect(mapStateToProps)(Highlights);
